import { styled } from '@mui/material/styles';

export const Cell = styled('input', {
  label: 'LiteralCell',
})(() => ({
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 10,
  paddingRight: 10,

  width: '100%',
  height: '100%',
}));
